var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sword-tag-wuk',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: 'Gutenberg flow',
    theme: 'sword-tooltip',
  }),expression:"{\n    content: 'Gutenberg flow',\n    theme: 'sword-tooltip',\n  }"}],staticClass:"gutenberg-highlight",attrs:{"color":"black","size":"small","text":"G"}})
}
var staticRenderFns = []

export { render, staticRenderFns }